/**
 * Marketing/tracking query params and URL hash (Cookiebot consent via #cc=...)
 * are lost when navigate() replaces the URL during flow steps.
 *
 * We capture whitelisted params + hash once at page load and re-append them
 * on every navigate() call via usePreservedNavigate.
 */

const WHITELISTED_PARAMS = [
    "_gl",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_id",
    "utm_term",
    "utm_content",
    "gclid",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "ttclid",
    "twclid",
    "li_fat_id",
    "cc",
] as const;

// Captured at module load — before processTokenFromUrl or any navigation can change the URL.
const capturedParams = new URLSearchParams();
const initialSearch = new URLSearchParams(window.location.search);
for (const key of WHITELISTED_PARAMS) {
    const value = initialSearch.get(key);
    if (value !== null) {
        capturedParams.set(key, value);
    }
}

const capturedHash = window.location.hash;

export function getPreservedSearchString(): string {
    const str = capturedParams.toString();
    return str ? `?${str}` : "";
}

export function getPreservedHash(): string {
    return capturedHash;
}

export function buildPreservedUrl(path: string): string {
    const hashIndex = path.indexOf("#");
    const pathWithoutHash = hashIndex >= 0 ? path.slice(0, hashIndex) : path;
    const existingHash = hashIndex >= 0 ? path.slice(hashIndex) : "";

    const queryIndex = pathWithoutHash.indexOf("?");
    const basePath = queryIndex >= 0 ? pathWithoutHash.slice(0, queryIndex) : pathWithoutHash;
    const existingSearch = queryIndex >= 0 ? pathWithoutHash.slice(queryIndex + 1) : "";

    const merged = new URLSearchParams(existingSearch);
    for (const [key, value] of capturedParams) {
        if (!merged.has(key)) {
            merged.set(key, value);
        }
    }

    const search = merged.toString();
    const hash = existingHash || capturedHash;

    let url = basePath;
    if (search) url += `?${search}`;
    if (hash) url += hash;
    return url;
}
